module.exports = __webpack_public_path__ + "img/logo.f567bc50.png";